var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { RouterConstants } from '../../../configuration/router.constants';
import * as Enumerable from 'linq';
import { BaseTemplate } from './base-template';
// import { setInterval } from 'timers';
import { DrawDateHelper } from '../../../models/modules/draw-date-helper';
import { TemplateType } from '../../../services/modules/brand-client.service';
import { computedFrom } from 'aurelia-binding';
import { Guid } from '../../../utilities/guid';
import moment from 'moment';
var BaseLotteries = /** @class */ (function (_super) {
    __extends(BaseLotteries, _super);
    function BaseLotteries(lotteryClientService, router, tokenClient, i18n, dialogClient, configClientService, routingHelper) {
        var _this = _super.call(this, router, i18n, lotteryClientService, dialogClient, tokenClient) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.routingHelper = routingHelper;
        _this.lotteryResults = [];
        _this.animating = false;
        _this.lotteryComboBoxItems = [];
        _this.lotteryDatesComboBoxItems = [];
        _this.defaultUserCurrencySymbol = tokenClient.getUserCurrency().symbol;
        _this.configClientService = configClientService;
        return _this;
    }
    Object.defineProperty(BaseLotteries.prototype, "selectedFilterDate", {
        get: function () {
            return this._selectedFilterDate;
        },
        set: function (x) {
            if (this._selectedFilterDate == x)
                return;
            this._selectedFilterDate = x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLotteries.prototype, "selectedLotteryId", {
        get: function () {
            return this._selectedLotteryId ? this._selectedLotteryId : this.lotteryId;
        },
        set: function (x) {
            if (this._selectedLotteryId == x)
                return;
            this._selectedLotteryId = x;
            if (!x)
                this.lotteryId = null;
        },
        enumerable: false,
        configurable: true
    });
    BaseLotteries.prototype.format = function (price) {
        if (price)
            return price.toFixed(2);
        return 0.00;
    };
    BaseLotteries.prototype.onLotteriesLoaded = function () {
        var _this = this;
        this.attachResultsToLotteries();
        this._intervalDrawDateChecker = window.setInterval(function () {
            _this.lotteries.forEach(function (lottery) {
                var drawDate = new Date(lottery.closingDateTime);
                if (new Date() > drawDate && lottery.closingDateTime) {
                    var calculatedDate = _this.calculateNextDrawDate(lottery, drawDate);
                    lottery.closingDateTime = calculatedDate;
                }
            });
        }, 5000);
        this.loadLotteryDates();
        this.lotteryComboBoxItems = [{ lotteryName: this.i18n.tr("lotteries-page-all-lotteries"), lotteryId: null }]
            .concat(this.lotteries.map(function (x) { return ({ lotteryName: x.lotteryName, lotteryId: x.lotteryId }); }));
    };
    BaseLotteries.prototype.detached = function () {
        _super.prototype.detached.call(this);
        if (this._intervalDrawDateChecker) {
            this._intervalDrawDateChecker = null;
        }
    };
    BaseLotteries.prototype.getAllResults = function () {
        return false;
    };
    BaseLotteries.prototype.activate = function (params) {
        var _this = this;
        var promise = _super.prototype.activate.call(this, params);
        this.lotteryClientService.getLobbyLatestResults({
            getAll: this.getAllResults()
        }).then(function (x) {
            _this.lotteryResults = x;
            _this.attachResultsToLotteries();
        }, function () {
        });
        return promise;
    };
    Object.defineProperty(BaseLotteries.prototype, "lotteryIdsForLotteryDrawDates", {
        get: function () {
            return this._selectedLotteryId ? this._selectedLotteryId.toString() : Enumerable.from(this.lotteryComboBoxItems).select(function (x) { return x.lotteryId; }).where(function (x) { return x != null; }).toJoinedString("|");
        },
        enumerable: false,
        configurable: true
    });
    BaseLotteries.prototype.calculateNextDrawDate = function (lottery, drawDate) {
        var calculatedDate = DrawDateHelper.calculateNextDrawDate(lottery.isCustom, 2, false, lottery.sunday, lottery.monday, lottery.tuesday, lottery.wednesday, lottery.thursday, lottery.friday, lottery.saturday, drawDate, lottery.ticketSalesClosingTime);
        var drawTimeDate = new Date(lottery.closingDateTime);
        calculatedDate.setHours(drawTimeDate.getHours());
        calculatedDate.setMinutes(drawTimeDate.getMinutes());
        return calculatedDate;
    };
    BaseLotteries.prototype.loadLotteryDates = function () {
        var _this = this;
        var distinctDrawDates = Enumerable.from(this.lotteries.map(function (x) {
            var calculatedDate = _this.calculateNextDrawDate(x, new Date(x.closingDateTime));
            return moment(calculatedDate).format("DD-MM-YYYY");
        })).distinct().toArray();
        var lotteryNextDrawDates = distinctDrawDates.map(function (x) { return ({ id: Guid.generateGuid(), name: x }); });
        this.lotteryDatesComboBoxItems = [{ name: this.i18n.tr("lotteries-page-most-recent"), id: null }].concat(lotteryNextDrawDates);
    };
    BaseLotteries.prototype.getDateId = function (lottery) {
        var calculatedDate = this.calculateNextDrawDate(lottery, lottery.closingDateTime);
        var cleanedDate = moment(calculatedDate).format("DD-MM-YYYY");
        var filteredDate = this.lotteryDatesComboBoxItems.filter(function (x) { return x.name == cleanedDate; });
        return filteredDate && filteredDate.length > 0 ? filteredDate[0].id : null;
    };
    BaseLotteries.prototype.attachResultsToLotteries = function () {
        var e_1, _a;
        if (this.lotteryResults && this.lotteries)
            try {
                for (var _b = __values(this.lotteryResults), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var result = _c.value;
                    var lottery = Enumerable.from(this.lotteries).firstOrDefault(function (x) { return x.lotteryId == result.lotteryId; });
                    if (!lottery)
                        continue;
                    lottery.result = result;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
    };
    BaseLotteries.prototype.getLotteryById = function (lotteryId) {
        return Enumerable.from(this.lotteries).where(function (x) { return x.lotteryId == lotteryId; }).firstOrDefault();
    };
    BaseLotteries.prototype.navigateToLotteryById = function (lotteryId) {
        var lottery = this.getLotteryById(lotteryId);
        this.navigateToLottery(lottery);
    };
    BaseLotteries.prototype.navigateToLottery = function (lottery) {
        this.routingHelper.navigateToLottery(lottery);
    };
    BaseLotteries.prototype.showInstantGameDialog = function (instantGame) {
        this.routingHelper.showInstantGameDialog(instantGame);
    };
    BaseLotteries.prototype.navigateToLotteryAndSubscribe = function (lottery) {
        var key = this.getLotteryKey(lottery.lotteryName);
        this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
            lotteryId: lottery.lotteryId,
            key: key,
            brandLotteryId: lottery.brandLotteryId,
            isSubscribe: true
        });
        window.dataLayer.push({
            "openedLotteryId": lottery.lotteryId,
            "openedLotteryName": lottery.lotteryName,
            "event": "navigate_lottery"
        });
    };
    BaseLotteries.prototype.isClosing = function (lottery) {
        var dayInMinutes = 1440;
        var date1 = new Date().getTime();
        var date2 = new Date(lottery.drawDate).getTime();
        // Calculate the difference in milliseconds
        var difference = date2 - date1;
        var minutes = Math.floor(difference / 1000 / 60);
        if (minutes <= dayInMinutes) {
            return true;
        }
        return false;
    };
    BaseLotteries.prototype.getConfig = function (page, config) {
        return __awaiter(this, void 0, void 0, function () {
            var json, bob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Config)];
                    case 1:
                        json = _a.sent();
                        bob = json[TemplateType.Config][page][config];
                        return [2 /*return*/, bob];
                }
            });
        });
    };
    __decorate([
        computedFrom("_selectedFilterDate"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], BaseLotteries.prototype, "selectedFilterDate", null);
    __decorate([
        computedFrom("_selectedLotteryId"),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], BaseLotteries.prototype, "selectedLotteryId", null);
    __decorate([
        computedFrom("_selectedLotteryId"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], BaseLotteries.prototype, "lotteryIdsForLotteryDrawDates", null);
    return BaseLotteries;
}(BaseTemplate));
export { BaseLotteries };
